import { useMutation } from "@tanstack/react-query";
import {
  deleteJournal,
  DeleteJournalRequest,
  journalsQueries,
} from "@entities/journal";
import { queryClient } from "@shared/lib/react-query";

export function useDeleteJournal({
  buildingObjectId,
}: {
  buildingObjectId: string;
  page: number;
  limit: number;
}) {
  return useMutation<void, Error, DeleteJournalRequest>({
    mutationFn: deleteJournal,

    onSuccess: () => {
      queryClient.invalidateQueries(
        journalsQueries.getDraftJournals({
          buildingObjectId,
        }),
      );
    },

    onError: () => {},
  });
}
